module.exports = __webpack_public_path__ + "img/012.92df368c.jpg";